import React from "react";
import classNames from "classnames";
import styles from "./UploadFileDialog.module.scss";
import Button from "../Button/Button";
import ErrorDialog from "../../../assets/img/upload-dialog-error.svg";

const UploadFileBodyError = (
  {
    onFileSelectClick,
    errorText
  }
) => {
  return (
    <>
      <div className={styles.BodyUploadFileError}>
        <div className={classNames(styles.UploadZone, styles.UploadZoneError, styles.JustifyContent)}>

          <div>
            <img id="ufbeErrorCargueImg" 
                 src={ErrorDialog}
                 alt={"Error al cargar el archivo"}/>
          </div>

          <div>
            <Button
              id="ufbeSeleccionarArchivoBtn"
              name="seleccionarArchivoBtn"
              type="button"
              typeStyle="ghost"
              notFullWidth
              cssClassName={styles.UploadButton}
              onClick={onFileSelectClick}>
              Volver a seleccionar otro archivo
            </Button>
          </div>

          <div>
            <span className={styles.UploadText}>{errorText}</span>
          </div>

        </div>
      </div>
    </>
  );
};

export default UploadFileBodyError;
